var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',[_c('app-bar',{attrs:{"app":""},on:{"drawerChange":_vm.drawerChange}}),_c('drawer',{ref:"drawerControl",attrs:{"mini":_vm.drawerAction}}),_c('layout-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }